var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvercas(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.777 7.625c0-2.917-2.789-4.994-5.553-4.208A5.433 5.433 0 0021.328.344a5.443 5.443 0 00-5.43 5.185 5.086 5.086 0 00-3.84 5.993c.04.186.265.259.405.13a4.428 4.428 0 013.337-1.151.24.24 0 00.214-.101c.317-.449.703-.85 1.143-1.18 3.109-2.339 7.618-.617 8.378 3.182a.24.24 0 00.145.175 5.022 5.022 0 012.78 2.826.243.243 0 00.227.155h2.265c2.193 0 4.013-1.746 4.047-3.939a4.005 4.005 0 00-3.222-3.994z",
    fill: "#2CACD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.061 13.782a3.731 3.731 0 00-3.72-4.063 3.735 3.735 0 00-3.574 2.646c-2.124-1.088-4.605.76-4.124 3.127-1.575 0-2.643 1.225-2.643 2.582a2.584 2.584 0 002.585 2.582H23.79a3.445 3.445 0 003.447-3.442 3.445 3.445 0 00-3.175-3.432z",
    fill: "#2CACD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.538c0-1.91-1.333-3.514-3.118-3.883C15.334 6.373 13.498 4.5 11.2 4.5c-1.7 0-3.157 1.03-3.812 2.499-2.174-.715-4.434 1.034-4.338 3.354-1.541.262-2.55 1.599-2.55 3.05 0 1.703 1.358 3.097 3.05 3.097H14.6c2.161 0 3.9-1.781 3.9-3.962z",
    fill: "#2CACD7",
    stroke: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvercas);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "65b1b3ed8de8dc52e53e697ff5f59059.svg";
export { MemoForwardRef as ReactComponent };